<template>
  <div class="hom-page">
    <Header />
    <div class="home-content">
      <div class="lunbo">
        <el-image style="width:100%" src="img/contactUs-banner.jpg" fit="contain"></el-image>
      </div>

      <div class="wrap">
        <div class="header">
          <div class="header-left"><span v-if="language === 'ch'">关于我们</span><span v-else>About US</span></div>
          <div class="header-right"> <span v-if="language === 'ch'">首页 > 关于我们 </span><span v-else>Home > About Us </span> </div>
        </div>
        <div class="conten-wrap">
          <div class="left">
            <router-link to="/contactUs">
              <div class="left-item"><i class="el-icon-caret-right"> </i><span v-if="language === 'ch'">联系我们</span><span v-else>Contact Us</span></div>
            </router-link>
            <!-- <router-link to="/contactMessage">
              <div class="left-item"><i class="el-icon-caret-right"> </i><span v-if="language === 'ch'">留言</span><span v-else>leave a message</span></div>
            </router-link> -->
          </div>
          <div class="right">
            <div class="advtop-info">
              <span class="advtop-info-item" v-if="language === 'ch'">深圳市美事来手袋有限公司</span>
                <span class="advtop-info-item" v-else>MSL HANDBAG FACTORY LIMITED</span>
                <span class="advtop-info-item"><span v-if="language === 'ch'">电话：</span><span v-else>TEL：</span> 0755-84012262 / 84012558</span>
                <span class="advtop-info-item"> <span v-if="language === 'ch'">传真：</span><span v-else>FAX：</span> 0755-84012100</span>
                <span class="advtop-info-item"><span v-if="language === 'ch'">邮箱：</span><span v-else>E-MAIL：</span>lawrence_chan@msl-bag.com、lawrence_chan@msl-bag.com、anna_wu@msl-bag.com</span>
                <span class="advtop-info-item" v-if="language === 'ch'">地址：深圳市龙岗区平湖镇良安田倍光工业园第8栋四楼</span>
                <span class="advtop-info-item"  v-else>Address：Block 8,Beiguang industrial zone,liang an tian village,pinghu district,shenzhen,guangdong,china</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '../components/header.vue'
import Footer from '../components/footer.vue'
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      language: ''
    }
  },
  methods: {},
  created() { },
  mounted() {
    this.language = localStorage.getItem("curlanguage");
   }
}
</script>

<style scoped>
a {
  text-decoration: none;
}
.home-content {
  width: 1130px;
  margin: 0 auto;
  height: calc(100vh - 190px);
}
.lunbo {
  margin: 12px 0;
}
.wrap {
  display: flex;
  flex-direction: column;
}
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  line-height: 48px;
}
.header-left {
  border-bottom: 1px solid #cccccc;
  width: 25%;
}
.header-right {
  border-bottom: 1px solid #cccccc;
  width: 70%;
  color: #cccccc;
  display: flex;
  justify-content: flex-end;
  float: right;
  font-size: 14px;
}
.conten-wrap {
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.left {
  line-height: 30px;
}
.left-item {
  cursor: pointer;
}
.left-item:hover {
  color: blue;
}
.right {
  width: 70%;
}
.advtop-info {
  display: flex;
  flex-direction: column;
  width: 100%;
  line-height: 28px;
  font-size: 14px;
  color: #000000;
}
</style>

